import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const Category = ({ as: Component = 'p', animationType, animationDelay = 0, children, className, ...rest })=>jsx(Component, {
        className: classNames('category', animationType, className),
        style: {
            '--animation-delay': animationDelay
        },
        ...rest,
        children: children
    });

export { Category };
